window.AddProductToCart = function(variantId, props) {
  $("body").addClass("loading");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": variantId,
      "quantity": 1,
      "properties": props
    },
    dataType: 'json',
    success: function() {
      $("body").removeClass("loading");
      window.fetchUpdatedCartData();
    },
    error: function() {
      console.error("Failed to add product to cart");
    }
  });
}

window.fetchUpdatedCartData = function() {
  $.ajax({
    type: 'GET',
    url: '?section_id=cart-drawer',
    success: function(response) {
      const cartDrawer = document.querySelector('.ctdrawer');
      if (cartDrawer) {
        cartDrawer.renderContents({
          sections: {
            'cart-drawer': response
          }
        });
      }
    },
    error: function() {
      console.error("Failed to fetch updated cart data");
    }
  });
}

$(document).ready(function() {
  
  const threshold1 = parseFloat($('.ctdrawer').attr('data-threshold1')) || 0;
  const threshold2 = parseFloat($('.ctdrawer').attr('data-threshold2')) || 0;
  const threshold3 = parseFloat($('.ctdrawer').attr('data-threshold3')) || 0;
  const freeProductVariantId = $('.ctdrawer').attr('data-free-prod-threshold2');

  // For manual add buttons
  $("body").on("click", ".m_freebieCTA, .m_addMoreCTA", function(e) {
    e.preventDefault();
    const btn = $(this);
    btn.addClass('is-loading');
    var id = $(this).attr("data-variant-id");
    window.AddProductToCart(id);
    setTimeout(function() {
      btn.removeClass('is-loading').addClass('is-added');
      setTimeout(function() {
        btn.removeClass('is-added');
      }, 2000);
    }, 500);
  });

  
  // --- Function to check and add/remove free product ---
  function checkAndAddFreeProduct() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100;
        const hasFreeProduct = cart.items.some(item => item.variant_id == freeProductVariantId);

        // console.log(`Cart total: €${cartTotal}, has free product: ${hasFreeProduct}`);

        // ✅ Threshold2 logic (auto add/remove)
        if (cartTotal > threshold2 && !hasFreeProduct) {
          window.AddProductToCart(freeProductVariantId);
        } 
        else if (cartTotal < threshold2 && hasFreeProduct) {
          removeFreeProduct(freeProductVariantId);
        }

        // ✅ Threshold1 logic (remove freebies only if present)
        if (cartTotal < threshold1) {
          removeAllFreeProductsIfPresent(cart);
        }
      })
      .catch(err => console.error('Error checking cart:', err));
  }

  // --- Remove the specific free product ---
  function removeFreeProduct(variantId) {
    // console.log('Removing free product: ', variantId);
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const freeItem = cart.items.find(item => item.variant_id == variantId);
        if (freeItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: freeItem.key, quantity: 0 })
          });
        }
      })
      .then(() => {
        window.fetchUpdatedCartData();
        // console.log('Free product removed');
      })
      .catch(err => console.error('Error removing free product:', err));
  }

  // ✅ Remove freebies shown under threshold1 only if they exist in the cart
  function removeAllFreeProductsIfPresent(cart) {
    // console.log('Checking for freebies to remove (below threshold1)');
    
    const freebieIds = $(".m_freebieCTA").map(function() {
      return $(this).attr("data-variant-id");
    }).get();

    const freebiesInCart = cart.items.filter(item => 
      freebieIds.includes(item.variant_id.toString())
    );

    if (freebiesInCart.length > 0) {
      // console.log('Removing freebies from cart:', freebiesInCart.map(i => i.variant_id));
      const removePromises = freebiesInCart.map(item =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
      );
      Promise.all(removePromises)
        .then(() => {
          window.fetchUpdatedCartData();
          // console.log('Freebie products removed (threshold1 rule)');
        })
        .catch(err => console.error('Error removing freebie products:', err));
    } else {
      // console.log('No freebies to remove');
    }
  }
});
